import React from 'react';
import type { CombinedFieldType } from '../../../@types/forms';
import type { RecordResult } from '../../../@types/records';
import type { EntityReference } from '../../../@types/views';
import RichtextareaRenderer from './richtextarea-renderer';
import RiskRatingRenderer from './riskrating-renderer';

/** common props the recordlink type-renderer receives */
export interface RendererProps {
  records: RecordResult[];
  valuePath: string | undefined;
  columnWidth: number | undefined;
  columnEntityReference: EntityReference;
  linkedFieldType: CombinedFieldType | undefined;
}

/**
 * Registry mapping linkedFieldType → renderer component.
 *
 * To support a new type, add an entry here and create a renderer file.
 *
 * Unregistered types fall through to RecordlinkBaseDataCell.
 */
const registry = new Map<CombinedFieldType, React.ComponentType<RendererProps>>();

// Register a renderer component for a specific linkedFieldType
function registerRenderer(fieldType: CombinedFieldType, component: React.ComponentType<RendererProps>) {
  registry.set(fieldType, component);
}

// Retrieve a renderer component for a specific linkedFieldType
export function getRecordlinkRenderer(
  fieldType: CombinedFieldType | undefined
): React.ComponentType<RendererProps> | undefined {
  return fieldType ? registry.get(fieldType) : undefined;
}

// Init the registry
registerRenderer('RISKRATING', RiskRatingRenderer);
registerRenderer('RICHTEXTAREA', RichtextareaRenderer);
